import React , { useContext } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { AuthContext } from '../context/AuthContext';




const HomePage = () => {
  const { loading, role } = useContext(AuthContext);
  if (loading) return <p>Loading layout...</p>;

  return (
    <LayoutWithNavbar key={role}>
      <div style={styles.heroSection}>
        <div style={styles.overlay}>
          <h1 style={styles.title}>Welcome to KJ Internal GST Portal</h1>
          <p style={styles.subtitle}>
            Effortlessly manage GST documents, reconcile invoices, and streamline compliance.
          </p>
        </div>
      </div>

    </LayoutWithNavbar>
  );
};

const styles = {
  heroSection: {
    background: 'linear-gradient(120deg, #1f2937, #4b5563)',
    color: '#fff',
    padding: '100px 30px 60px',
    textAlign: 'center',
    position: 'relative',
  },
  overlay: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  title: {
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '20px'
  },
  subtitle: {
    fontSize: '18px',
    fontWeight: '400',
    color: '#d1d5db'
  },
  featuresSection: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
    padding: '40px 30px',
    backgroundColor: '#f3f4f6'
  },
  featureCard: {
    backgroundColor: '#ffffff',
    width: '280px',
    padding: '24px',
    borderRadius: '10px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
    textAlign: 'center',
    transition: 'transform 0.3s ease',
  },
  featureTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '10px',
    color: '#1f2937'
  },
  featureDesc: {
    fontSize: '15px',
    color: '#4b5563',
    lineHeight: '1.6'
  }
};

export default HomePage;
